"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = Button;
var _Button2 = _interopRequireDefault(require("@mui/material/Button"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function Button({
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(StyledButton, _extends({
    size: "small"
  }, props));
}
const StyledButton = (0, _styledComponents.styled)(_Button2.default)`
  && {
    border-radius: 1000px;
    text-transform: initial;
  }

  &.MuiButton-contained:not(.MuiButton-containedPrimary):not(.MuiButton-containedSecondary):not(
      .dangerous
    ) {
    background-color: #fff;
  }
`;